import { CASINO_TABS } from '../constants';
import { getCasinoFreeSpinsAvailability } from '../helpers/casino';
import { useCasinoMarketplace } from '../queries/casino';

const useCasinoTabs = () => {
  const { data, isError } = useCasinoMarketplace();
  const availability = getCasinoFreeSpinsAvailability(isError ? undefined : data);

  return CASINO_TABS.filter((tab) => tab.value !== 'free-spins' || availability.status !== 'disabled');
};

export default useCasinoTabs;
